module.exports = __webpack_public_path__ + "static/media/expand-your-reach.d040f5cb.png";